import { CITY_TYPE, FROM_MANUAL, MESSAGE_TEMPLATE } from '../constants';

export const getModalConfig = (preselectedCityObj, currentCityObj, nearByCityObj) => {
  const ctaData = {};
  const cityObj = {};
  cityObj.airportCode = currentCityObj?.airportCode;
  if (currentCityObj?.airportCode && nearByCityObj === null) {
    ctaData.ctaLeft = 'Cancel';
    ctaData.ctaRight = 'Yes, Update';
    cityObj.cancel = preselectedCityObj;
    ctaData.reload = true;
    cityObj.update = currentCityObj;
    cityObj.messageTemplate = MESSAGE_TEMPLATE.CITY_SHOWN;
  } else if (currentCityObj?.airportCode === null && nearByCityObj?.length > 0) {
    ctaData.ctaLeft = 'NO, USE CURRENT LOCATION';
    ctaData.ctaRight = 'Update';
    cityObj.cancel = currentCityObj;
    ctaData.reload = true;
    ctaData.closebtn = true;
    cityObj.messageTemplate = MESSAGE_TEMPLATE.NEARBY_CITY_SHOWN;
  } else if (nearByCityObj === null) {
    ctaData.ctaRight = 'OKAY';
    ctaData.reload = false;
    cityObj.messageTemplate = MESSAGE_TEMPLATE.NO_CITY;
  } else {
    ctaData.ctaLeft = 'Cancel';
    ctaData.ctaRight = 'Yes, Update';
    cityObj.cancel = preselectedCityObj;
    ctaData.reload = true;
    cityObj.messageTemplate = MESSAGE_TEMPLATE.CITY_SHOWN;
  }
  return { ...ctaData, ...cityObj };
};

export const getLocationEvarValue = (fromLocationData = {}) =>
  fromLocationData.from &&
  `${fromLocationData.from ?? FROM_MANUAL} | ${
    fromLocationData.airportCode === null ? CITY_TYPE.NON_AIRPORT : CITY_TYPE.NON_AIRPORT
  }`;
